import ShopSignUp from '@/features/auth/sign-up/shop-sign-up'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/(auth)/shop-sign-up')({
  component: ShopSignUp,
})
